import {
  configureStore,
  //   ThunkAction,
  //   Action,
  //   getDefaultMiddleware,
} from '@reduxjs/toolkit';

// import logger from 'redux-logger';
import walletSlice from '../slice/walletSlice';
import saleSlice from '../slice/saleSlice';
import saleBoardSlice from '../slice/saleBoardSlice';
import purchaseSlice from '../slice/purchaseSlice';
import configSlice from '../slice/configSlice';

export const store = configureStore({
  reducer: {
    walletSlice: walletSlice,
    saleSlice: saleSlice,
    saleBoardSlice: saleBoardSlice,
    purchaseSlice: purchaseSlice,
    configSlice: configSlice,
  },
  //middleware: getDefaultMiddleware().concat(logger),
});

// export type AppDispatch = typeof store.dispatch;
// export type RootState = ReturnType<typeof store.getState>;
// export type AppThunk<ReturnType = void> = ThunkAction<
//     ReturnType,
//     RootState,
//     undefined,
//     Action<string>
// >;
